"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceDepositsListCtl = /** @class */ (function (_super) {
    __extends(FinanceDepositsListCtl, _super);
    function FinanceDepositsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_player_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_email; });
        _this.dk_player_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_locked; });
        _this.dk_deposit_basis_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_basis_title; });
        _this.dk_deposit_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_currency_title; });
        _this.dk_amount_in_deposit_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_deposit_currency_without_comission; });
        _this.dk_amount_in_deposit_currency_with_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_deposit_currency_with_comission; });
        _this.dk_player_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_title; });
        _this.dk_amount_in_player_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_without_comission; });
        _this.dk_amount_in_player_currency_with_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_with_comission; });
        _this.dk_exchange_rate_deposit_to_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.exchange_rate_deposit_to_player; });
        _this.dk_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_before; });
        _this.dk_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_after; });
        _this.dk_deposit_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_code; });
        _this.dk_deposit_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_title; });
        _this.dk_deposit_state_complete = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_complete; });
        _this.dk_deposit_state_error = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_state_error; });
        _this.dk_deposit_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_type_code; });
        _this.dk_deposit_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_type_title; });
        _this.dk_promo_code_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_id; });
        _this.dk_promo_code_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_code_code; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_raw_gws_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.raw_gws_title; });
        _this.dk_raw_prv_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.raw_prv_title; });
        _this.dk_gws_pay_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_pay_tag; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_outer_transaction_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.outer_transaction_id; });
        _this.dk_active_bonus_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.active_bonus_id; });
        _this.dk_active_bonus_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.active_bonus_title; });
        _this.dk_dt_gws_tx_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.dt_gws_tx_id; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceDepositsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
            deposit_status_filter: [],
            deposit_type_filter: []
        };
    };
    FinanceDepositsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceDepositsListCtl.prototype.LoadRangeDataByBrandsList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListDepositsByBrandIdAndDateRangeGet.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            complete_only: data.complete_only,
            all_flowtypes: data.allMoneyflowTypes,
            flow_types_list: data.moneyflow_types,
            login_part: data.login_part,
            is_filter_login_part: data.is_filter_login_part,
            email_part: data.email_part,
            is_filter_email_part: data.is_filter_email_part,
            transaction_part: data.transaction_part,
            is_filter_transaction_part: data.is_filter_transaction_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.deposit_status_filter = [];
            var deposit_status_filter_map = new Map();
            //
            _this.DATA.deposit_type_filter = [];
            var deposit_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!deposit_status_filter_map.get(resp.list[i].deposit_state_title)) {
                    _this.DATA.deposit_status_filter.push({ text: resp.list[i].deposit_state_title, value: resp.list[i].deposit_state_title });
                    deposit_status_filter_map.set(resp.list[i].deposit_state_title, resp.list[i].deposit_state_title);
                }
                if (!deposit_type_filter_map.get(resp.list[i].deposit_type_title)) {
                    _this.DATA.deposit_type_filter.push({ text: resp.list[i].deposit_type_title, value: resp.list[i].deposit_type_title });
                    deposit_type_filter_map.set(resp.list[i].deposit_type_title, resp.list[i].deposit_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    player_locked: resp.list[i].player_locked,
                    deposit_basis_title: resp.list[i].deposit_basis_title,
                    deposit_currency_title: resp.list[i].deposit_currency_title,
                    amount_in_deposit_currency_without_comission: resp.list[i].amount_in_deposit_currency_without_comission,
                    amount_in_deposit_currency_with_comission: resp.list[i].amount_in_deposit_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    exchange_rate_deposit_to_player: resp.list[i].exchange_rate_deposit_to_player,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    deposit_state_code: resp.list[i].deposit_state_code,
                    deposit_state_title: resp.list[i].deposit_state_title,
                    deposit_type_code: resp.list[i].deposit_type_code,
                    deposit_type_title: resp.list[i].deposit_type_title,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_code: resp.list[i].promo_code_code,
                    raw_gws_title: resp.list[i].raw_gws_title,
                    raw_prv_title: resp.list[i].raw_prv_title,
                    gws_pay_tag: resp.list[i].gws_pay_tag,
                    deposit_state_complete: resp.list[i].deposit_state_complete,
                    deposit_state_error: resp.list[i].deposit_state_error,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    active_bonus_id: resp.list[i].active_bonus_id,
                    active_bonus_title: resp.list[i].active_bonus_title,
                    dt_gws_tx_id: resp.list[i].dt_gws_tx_id,
                    dt_url: resp.list[i].dt_url,
                    dt_time_to_expire: resp.list[i].dt_time_to_expire
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceDepositsListCtl.prototype.LoadRangeDataByBrandsListEx = function (data, onDone) {
        var _this = this;
        webAApi_1.ListDepositsByBrandIdAndDateRangeGetEx.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            complete_only: data.complete_only,
            all_flowtypes: data.allMoneyflowTypes,
            flow_types_list: data.moneyflow_types,
            login_part: data.login_part,
            is_filter_login_part: data.is_filter_login_part,
            email_part: data.email_part,
            is_filter_email_part: data.is_filter_email_part,
            transaction_part: data.transaction_part,
            is_filter_transaction_part: data.is_filter_transaction_part,
            is_filter_gws_transaction_part: data.is_filter_gws_transaction_part,
            gws_transaction_part: data.gws_transaction_part
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.deposit_status_filter = [];
            var deposit_status_filter_map = new Map();
            //
            _this.DATA.deposit_type_filter = [];
            var deposit_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!deposit_status_filter_map.get(resp.list[i].deposit_state_title)) {
                    _this.DATA.deposit_status_filter.push({ text: resp.list[i].deposit_state_title, value: resp.list[i].deposit_state_title });
                    deposit_status_filter_map.set(resp.list[i].deposit_state_title, resp.list[i].deposit_state_title);
                }
                if (!deposit_type_filter_map.get(resp.list[i].deposit_type_title)) {
                    _this.DATA.deposit_type_filter.push({ text: resp.list[i].deposit_type_title, value: resp.list[i].deposit_type_title });
                    deposit_type_filter_map.set(resp.list[i].deposit_type_title, resp.list[i].deposit_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    player_locked: resp.list[i].player_locked,
                    deposit_basis_title: resp.list[i].deposit_basis_title,
                    deposit_currency_title: resp.list[i].deposit_currency_title,
                    amount_in_deposit_currency_without_comission: resp.list[i].amount_in_deposit_currency_without_comission,
                    amount_in_deposit_currency_with_comission: resp.list[i].amount_in_deposit_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    exchange_rate_deposit_to_player: resp.list[i].exchange_rate_deposit_to_player,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    deposit_state_code: resp.list[i].deposit_state_code,
                    deposit_state_title: resp.list[i].deposit_state_title,
                    deposit_type_code: resp.list[i].deposit_type_code,
                    deposit_type_title: resp.list[i].deposit_type_title,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_code: resp.list[i].promo_code_code,
                    raw_gws_title: resp.list[i].raw_gws_title,
                    raw_prv_title: resp.list[i].raw_prv_title,
                    gws_pay_tag: resp.list[i].gws_pay_tag,
                    deposit_state_complete: resp.list[i].deposit_state_complete,
                    deposit_state_error: resp.list[i].deposit_state_error,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    active_bonus_id: resp.list[i].active_bonus_id,
                    active_bonus_title: resp.list[i].active_bonus_title,
                    dt_gws_tx_id: resp.list[i].dt_gws_tx_id,
                    dt_url: resp.list[i].dt_url,
                    dt_time_to_expire: resp.list[i].dt_time_to_expire
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceDepositsListCtl.prototype.LoadRangeDataByPlayerId = function (data, onDone) {
        var _this = this;
        webAApi_1.ListDepositsByUsrPlayerIdAndDateRangeGet.exec({
            usr_player_id: data.playerId,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.deposit_status_filter = [];
            var deposit_status_filter_map = new Map();
            //
            _this.DATA.deposit_type_filter = [];
            var deposit_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!deposit_status_filter_map.get(resp.list[i].deposit_state_title)) {
                    _this.DATA.deposit_status_filter.push({ text: resp.list[i].deposit_state_title, value: resp.list[i].deposit_state_title });
                    deposit_status_filter_map.set(resp.list[i].deposit_state_title, resp.list[i].deposit_state_title);
                }
                if (!deposit_type_filter_map.get(resp.list[i].deposit_type_title)) {
                    _this.DATA.deposit_type_filter.push({ text: resp.list[i].deposit_type_title, value: resp.list[i].deposit_type_title });
                    deposit_type_filter_map.set(resp.list[i].deposit_type_title, resp.list[i].deposit_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    player_login: resp.list[i].player_login,
                    player_id: data.playerId,
                    player_email: resp.list[i].player_email,
                    player_locked: false,
                    deposit_basis_title: resp.list[i].deposit_basis_title,
                    deposit_currency_title: resp.list[i].deposit_currency_title,
                    amount_in_deposit_currency_without_comission: resp.list[i].amount_in_deposit_currency_without_comission,
                    amount_in_deposit_currency_with_comission: resp.list[i].amount_in_deposit_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    exchange_rate_deposit_to_player: resp.list[i].exchange_rate_deposit_to_player,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    deposit_state_code: resp.list[i].deposit_state_code,
                    deposit_state_title: resp.list[i].deposit_state_title,
                    deposit_type_code: resp.list[i].deposit_type_code,
                    deposit_type_title: resp.list[i].deposit_type_title,
                    promo_code_id: resp.list[i].promo_code_id,
                    promo_code_code: resp.list[i].promo_code_code,
                    raw_gws_title: resp.list[i].raw_gws_title,
                    raw_prv_title: resp.list[i].raw_prv_title,
                    gws_pay_tag: resp.list[i].gws_pay_tag,
                    deposit_state_complete: resp.list[i].deposit_state_complete,
                    deposit_state_error: resp.list[i].deposit_state_error,
                    outer_transaction_id: resp.list[i].outer_transaction_id,
                    active_bonus_id: resp.list[i].active_bonus_id,
                    active_bonus_title: resp.list[i].active_bonus_title,
                    dt_gws_tx_id: resp.list[i].dt_gws_tx_id,
                    dt_url: resp.list[i].dt_url,
                    dt_time_to_expire: resp.list[i].dt_time_to_expire
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return FinanceDepositsListCtl;
}(BaseController_1.BaseController));
exports.FinanceDepositsListCtl = FinanceDepositsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_deposits_list/ctl/FinanceDepositsListCtl.ts
// module id = 874
// module chunks = 0